import React from "react";
 
var onLoading=require('../_source/onload.js');
 
 
export default class formshow extends React.Component {

    state = {
        Src : "",
        display : "none",
        display2 : "",
    } 
    componentDidMount(){ 
        this.setState({Src:this.props.url}); 
    }
    onClose = (e) =>{
        this.props.close();
        
    }
    onShow = (e) =>{  
        this.setState({display:"",display2:"none"});
        setTimeout(() => {
             onLoading.onLoading("N");
        }, 10);
       
    }
    render() {
        var mYsty = {
            position:"fixed",
            width:"100%",
            height:"100vh",
            left:"0px",
            top:"0px",
            padding:"65px 50px",
            background:"rgba(0,0,0,0.5)",
            "z-index" : "100"
        };
        return (
                <div style={mYsty} onClick={this.onClose}>
                <div  style={{display:this.state.display2}}> 
                        {onLoading.onLoading("Y")}
                    </div> 
                    <iframe src={this.state.Src} type="application/pdf" width="80%" height="100%" onLoad={this.onShow} style={{display:this.state.display}}></iframe>

                </div>
        );
    }
}
